import { RandomHelper } from "./RandomHelper";

import { IQuiltSize } from "../Model/IQuiltSize";
import { IQuiltParams } from "../Model/IQuiltParams";
import { BlockOrdering } from "../Model/BlockOrdering";
import { IBlockQuiltParams } from "../Model/IBlockQuiltParams";
import { IGeneralQuiltParams } from "../Model/IGeneralQuiltParams";
import { IColorPaletteReference } from "../Model/IColorPaletteReference";

const DefaultQuiltParams: IQuiltParams = {
    general: {
        seed: 0,
        version: 0,
        rows: 4,
        columns: 3,
        padding: {
            width: 1,
            height: 1
        },
    },

    block: {
        randomCount: 2,
        ordering: BlockOrdering.Alternate,

        padding: {
            width: 0,
            height: 0
        }
    },
};

function isPaddingEqual(a?: IQuiltSize, b?: IQuiltSize): boolean {
    if (!!a !== !!b) {
        return false;
    }

    if (!a || !b) {
        return true;
    }

    if (a.width !== b.width) {
        return false;
    }

    if (a.height !== b.height) {
        return false;
    }

    return true;
}

function isPaletteRefEqual(a?: IColorPaletteReference, b?: IColorPaletteReference): boolean {
    if (!!a !== !!b) {
        return false;
    }

    if (!a || !b) {
        return true;
    }

    if (a.index !== b.index) {
        return false;
    }

    if (a.shuffle !== b.shuffle) {
        return false;
    }

    return true;
}

function isGeneralEqual(a: IQuiltParams, b: IQuiltParams): boolean {
    const ag = a.general;
    const bg = b.general;

    if (ag.rows !== bg.rows) {
        return false;
    }

    if (ag.columns !== bg.columns) {
        return false;
    }

    if (!isPaddingEqual(ag.padding, bg.padding)) {
        return false;
    }

    if (!isPaletteRefEqual(ag.backgroundPaletteRef, bg.backgroundPaletteRef)) {
        return false;
    }

    return true;
}

function isBlockEqual(a: IQuiltParams, b: IQuiltParams): boolean {
    const ab = a.block;
    const bb = b.block;

    if (ab.randomCount !== bb.randomCount) {
        return false;
    }

    if (!isPaddingEqual(ab.padding, bb.padding)) {
        return false;
    }

    if (ab.paletteRef !== bb.paletteRef) {
        return false;
    }

    if (!isPaletteRefEqual(ab.paletteRef, bb.paletteRef)) {
        return false;
    }

    if (ab.ordering !== bb.ordering) {
        return false;
    }

    return true;
}

export class QuiltParamsHelper {
    public static makeDefault(version: number): IQuiltParams {
        const params = {
            ...DefaultQuiltParams,
            general: {
                ...DefaultQuiltParams.general,
                seed: RandomHelper.randomInt32(),
                version: version,
            }
        };

        return params;
    }

    public static regenerate(params: IQuiltParams): IQuiltParams {
        return {
            ...params,
            general: {
                ...params.general,
                seed: RandomHelper.randomInt32()
            }
        };
    }

    public static hasChanges(params: IQuiltParams): boolean {
        if (!isGeneralEqual(params, DefaultQuiltParams)) {
            return true;
        }

        if (!isBlockEqual(params, DefaultQuiltParams)) {
            return true;
        }

        return false;
    }

    public static setGeneralParams(params: IQuiltParams, general: IGeneralQuiltParams): IQuiltParams {
        return {
            ...params,
            general
        }
    }

    public static setBlockParams(params: IQuiltParams, block: IBlockQuiltParams): IQuiltParams {
        return {
            ...params,
            block
        }
    }
}